export type FamilyListRecord = {
  familyName?: string;
  parent1FirstName?: string;
  parent1LastName?: string;
  parent2FirstName?: string;
  parent2LastName?: string;
  childCount?: number;
  childrenCount?: number;
  children?: FamilyListChild[];
  kids?: unknown[];
  parents?: unknown[];
};

export type FamilyListChild = {
  id?: string | number;
  firstName?: string;
  lastName?: string;
  dateBirth?: string | number[] | Date | null;
};

export const getChildCount = (family: FamilyListRecord): number =>
  typeof family?.childCount === "number"
    ? family.childCount
    : Array.isArray(family?.children)
      ? family.children.length
      : typeof family?.childrenCount === "number"
        ? family.childrenCount
        : Array.isArray(family?.kids)
          ? family.kids.length
          : 0;

export const hasNoChildren = (family: FamilyListRecord): boolean =>
  getChildCount(family) === 0;

export const hasNoParents = (family: FamilyListRecord): boolean =>
  !family?.parent1FirstName &&
  !family?.parent1LastName &&
  !family?.parent2FirstName &&
  !family?.parent2LastName &&
  (!Array.isArray(family?.parents) || family.parents.length === 0);

export const isEmptyFamily = (family: FamilyListRecord): boolean =>
  hasNoParents(family) && hasNoChildren(family);

export const matchesFamilySearch = (
  family: FamilyListRecord,
  query: string,
): boolean => {
  const normalizedQuery = query.trim().toLocaleLowerCase();
  if (!normalizedQuery) return true;

  return [
    family.familyName,
    family.parent1FirstName,
    family.parent1LastName,
    family.parent2FirstName,
    family.parent2LastName,
    ...(Array.isArray(family.children)
      ? family.children.flatMap((child) => [child.firstName, child.lastName])
      : []),
  ].some((value) => value?.toLocaleLowerCase().includes(normalizedQuery));
};
